/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeLocationCities.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Location Cities Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, July 07, 2019 - 04:35:28 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      07/07/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const LOCATIONCITY_LIST_CONTAINER_LOADED = 'LOCATIONCITY_LIST_CONTAINER_LOADED';
export const LOCATIONCITY_LIST_CONTAINER_UNLOADED = 'LOCATIONCITY_LIST_CONTAINER_UNLOADED';
export const LOCATIONCITY_LIST_TABLE_LOADED = 'LOCATIONCITY_LIST_TABLE_LOADED';
export const LOCATIONCITY_LIST_TABLE_UNLOADED = 'LOCATIONCITY_LIST_TABLE_UNLOADED';

export const LOCATIONCITY_LIST_CHANGE_GROUP = 'LOCATIONCITY_LIST_CHANGE_GROUP';
export const LOCATIONCITY_SELECT_ROW = 'LOCATIONCITY_SELECT_ROW';

export const LOCATIONCITY_ADD = 'LOCATIONCITY_ADD';
export const LOCATIONCITY_EDIT = 'LOCATIONCITY_EDIT';
export const LOCATIONCITY_DELETE = 'LOCATIONCITY_DELETE';
export const LOCATIONCITY_OPEN_WARNING = 'LOCATIONCITY_OPEN_WARNING';
export const LOCATIONCITY_CLOSE_WARNING = 'LOCATIONCITY_CLOSE_WARNING';
export const LOCATIONCITY_DELETE_DISABLE = 'LOCATIONCITY_DELETE_DISABLE';
export const LOCATIONCITY_VIEW_CHILD_ITEMS = 'LOCATIONCITY_VIEW_CHILD_ITEMS';

export const LOCATIONCITY_EDIT_CONTAINER_LOADED = 'LOCATIONCITY_EDIT_CONTAINER_LOADED';
export const LOCATIONCITY_EDIT_CONTAINER_UNLOADED = 'LOCATIONCITY_EDIT_CONTAINER_UNLOADED';
export const LOCATIONCITY_EDIT_FORM_LOADED = 'LOCATIONCITY_EDIT_FORM_LOADED';
export const LOCATIONCITY_EDIT_FORM_UNLOADED = 'LOCATIONCITY_EDIT_FORM_UNLOADED';

export const LOCATIONCITY_SET_GROUP_SELECT = 'LOCATIONCITY_SET_GROUP_SELECT';
export const LOCATIONCITY_EDIT_DATA_LOAD = 'LOCATIONCITY_EDIT_DATA_LOAD';

export const LOCATIONCITY_EDIT_CONTAINER_SUBMIT = 'LOCATIONCITY_EDIT_CONTAINER_SUBMIT';
export const LOCATIONCITY_EDIT_CONTAINER_CANCEL = 'LOCATIONCITY_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeLocationCities.js